<button mat-button mat-icon-button type="button" (click)="openDialog($event)" title="{{'button.help.hint' | translate}}"
    tabindex="-1">
    <span class="fal fa-fw fa-info-circle adn-color-primary"></span>
</button>